import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import vi from "date-fns/locale/vi";
import TableHeader from "../../../../../components/TableHeader";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BusRouteController from "../../../../../services/system/bus/bus-route-controller";
import Utils from "../../../../../utils/utils";
import {GRADE_ALL} from "../../../../../components/Grade";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import FoodController from "../../../../../services/system/food/food-controller";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateMenuManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listBuaAn: [
                {
                    "sang": "",
                    "trua": "",
                    "toi": ""
                },
                {
                    "sang": "",
                    "trua": "",
                    "toi": ""
                },
                {
                    "sang": "",
                    "trua": "",
                    "toi": ""
                }
            ],
            listMonAn: [
                {
                    "id": "0",
                    "name": "Tên món ăn 1",
                },
                {
                    "id": "0",
                    "name": "Tên món ăn 2",
                },
            ],
            listFoodEat: {},
            listFoodEatSelect: [],
            allFood: [],
            listFoodSelect: [],
            name: "",
            code: "",
            pricePerDay: 0,

            foodEatSangId: [],
            foodEatSangName: [],

            foodEatTruaId: [],
            foodEatTruaName: [],

            foodEatToiId: [],
            foodEatToiName: [],

            foodId: -1,
            foodName: [],

            content: "",
            pageNumber: 0,
            pageSize: 10,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "sang",
                    name: "Bữa sáng",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "trua",
                    name: "Bữa trưa",
                    style: {textAlign: "center"},
                    sort: false
                },

                {
                    id: "toi",
                    name: "Bữa xế",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ],
            headerMonAn: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên thực phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "dinhluong",
                    name: "Khối lượng/1 trẻ(g)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "dv",
                    name: "Đơn vị tính",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "bo",
                    name: "Thải bỏ(%)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tong",
                    name: "Tổng thực mua",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Giá tiền/1 đơn vị",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                },
                {
                    id: "money",
                    name: "Giá tiền/1 trẻ(VNĐ)",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ],
        };
    }

    componentWillMount() {
        this.getListFoodEat("")
        this.getListFood("")
    }
    getListFoodEat(type) {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: "",
            type: type,
            state: "ACTIVE",
            pageNumber: 0,
            pageSize: 1000,
            sort: "created_at desc",

        };
        FoodController.searchFoodEat(payload, res => {
            if (res.success) {
                res.data.content.forEach((item, index) => {
                    let listFood = this.state.listFoodEat[item.type]
                    if (listFood == undefined)
                        listFood = []
                    const isHave = listFood.find(element => {
                        if (element.id === item.id) {
                            return true;
                        }
                        return false;
                    });
                    if (!isHave){
                        listFood.push(item)
                        this.state.listFoodEat[item.type] = listFood
                        this.setState(this.state.listFoodEat)
                    }
                })
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    getListFood(foodName) {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            foodCategoryId: -1,
            name: foodName,
            usual: "",
            pageNumber: 0,
            pageSize: 100,
            sort: "created_at desc"
        };
        FoodController.searchFood(payload, res => {
            this.setState({
                allFood: res.data.content,
            });
        })
    }
    getFoodEat(type){
        let list = this.state.listFoodEat[type];
        if (list == undefined)
            return []
        return list
    }
    setFoodEat(foodId){
        let listFoodSang = this.state.foodEatSangId.filter(item => item > 0)
        let listFoodTrua = this.state.foodEatTruaId.filter(item => item > 0)
        let listFoodToi = this.state.foodEatToiId.filter(item => item > 0)
        if (foodId != undefined){
            if (listFoodSang.includes(foodId) || listFoodTrua.includes(foodId) || listFoodToi.includes(foodId)){
                toast.error("Món ăn đã được chọn! Vui lòng chọn món ăn khác", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                return false;
            }
            this.state.listFoodEatSelect.push(foodId)
            this.setState(this.state.listFoodEatSelect)
        }else {
            this.state.listFoodEatSelect = []
            this.state.listFoodEatSelect.concat(listFoodSang)
            this.state.listFoodEatSelect.concat(listFoodTrua)
            this.state.listFoodEatSelect.concat(listFoodToi)
            this.setState(this.state.listFoodEatSelect)
        }
    }
    onCreate = () => {
        let pricePerDay = parseFloat(this.state.pricePerDay.toString().replaceAll(",", ""))
        let listFoodSang = this.state.foodEatSangId.filter(item => item > 0)
        let listFoodTrua = this.state.foodEatTruaId.filter(item => item > 0)
        let listFoodToi = this.state.foodEatToiId.filter(item => item > 0)
        let listFoodEatSelect = []
        listFoodEatSelect = listFoodEatSelect.concat(listFoodSang)
        listFoodEatSelect = listFoodEatSelect.concat(listFoodTrua)
        listFoodEatSelect = listFoodEatSelect.concat(listFoodToi)
        if (this.state.name.length < 0){
            toast.error("Vui lòng nhập tên thực đơn");
        }else if(this.state.code.length < 0){
            toast.error("Vui lòng nhập mã thực đơn");
        }else if(pricePerDay < 0){
            toast.error("Vui lòng nhập số tiền");
        }else if(listFoodEatSelect.length < 1){
            toast.error("Vui lòng nhập món ăn");
        }else if(this.state.listFoodSelect.length < 1){
            toast.error("Vui lòng chọn thực phẩm");
        }
        else {
            let listFoodSelect = this.state.listFoodSelect.filter(item => item.foodId > 0)
            let payload = {
                "name": this.state.name,
                "pricePerDay": pricePerDay,
                yearId: parseInt(getSchoolYear()),
                "code": this.state.code,
                "autoCompleteFoods": listFoodSelect,
                "foodEatIds": listFoodEatSelect
            }
            FoodController.createMenu(payload, res => {
                if (res.success){
                    toast.success("Đăng ký thành công!")
                    this.setState({
                        showLoading: false,
                    });
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    getPrice(index){
        return 0
    }
    getUnit(index){
        return "kg"
    }
    render() {
        let {header, headerMonAn, listBuaAn, listMonAn} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="menu" parentClass="menu-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới thực đơn"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Thêm mới thực đơn</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin chung thực đơn
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên thực đơn<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="Tên thực đơn"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã thưc đơn<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="VD: M21001"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.code}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            code: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tiền thu 1 học sinh/ngày(VNĐ)<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="VD: 90.000"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.pricePerDay)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            pricePerDay: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Chi tiết món ăn 1 ngày
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!listBuaAn ||
                                                                listBuaAn.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listBuaAn &&
                                                                    listBuaAn.length > 0 &&
                                                                    listBuaAn?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumber * this.state.pageSize +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <Autocomplete
                                                                                    size="small"
                                                                                    options={this.getFoodEat("SANG")}
                                                                                    getOptionLabel={option => option.name?option.name:""}
                                                                                    style={{width: '100%'}}
                                                                                    inputValue={this.state.foodEatSangName[index] == undefined?"":this.state.foodEatSangName[index]}
                                                                                    renderInput={params => {
                                                                                        return <TextField
                                                                                            placeholder='Nhập tên món ăn sáng'
                                                                                            {...params}
                                                                                            InputLabelProps={{
                                                                                                shrink: true,
                                                                                                style: {
                                                                                                    fontSize: 17,
                                                                                                    backgroundColor: "#FFF",
                                                                                                    paddingRight: 10,
                                                                                                    paddingLeft: 10,
                                                                                                    color: '#2e495c',
                                                                                                    fontWeight: 500,
                                                                                                    fontFamily: 'Montserrat'
                                                                                                }
                                                                                            }}
                                                                                            label=""
                                                                                            variant="outlined"
                                                                                            fullWidth
                                                                                        />
                                                                                    }}
                                                                                    onInputChange={(event, val) => {
                                                                                        if (event !== null){
                                                                                            this.state.foodEatSangName[index] = val
                                                                                            this.setState(this.state.foodEatSangName)
                                                                                            if (val === ""){
                                                                                                this.state.foodEatSangId[index] = -1;
                                                                                                this.state.foodEatSangName[index] = "";
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    onChange={(e, val) => {
                                                                                        if (val?.id != undefined){
                                                                                            if (!this.state.foodEatSangId.includes(val?.id)){
                                                                                                this.state.foodEatSangId[index] = val?.id;
                                                                                                this.setState(this.state.foodEatSangId)
                                                                                            }else {
                                                                                                this.state.foodEatSangName[index] = "";
                                                                                                this.state.foodEatSangId[index] = -1;
                                                                                                this.setState(this.state.foodEatSangName)
                                                                                                this.setState(this.state.foodEatSangId)
                                                                                                toast.error("Món ăn đã được chọn! Vui lòng chọn món ăn khác", {
                                                                                                    position: toast.POSITION.TOP_RIGHT,
                                                                                                    autoClose: 3000
                                                                                                });
                                                                                            }
                                                                                        }else {
                                                                                            this.state.foodEatSangName[index] = "";
                                                                                            this.state.foodEatSangId[index] = -1;
                                                                                            this.setState(this.state.foodEatSangName)
                                                                                            this.setState(this.state.foodEatSangId)
                                                                                        }
                                                                                    }}

                                                                                />
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <Autocomplete
                                                                                    size="small"
                                                                                    options={this.getFoodEat("TRUA")}
                                                                                    getOptionLabel={option => option.name?option.name:""}
                                                                                    style={{width: '100%'}}
                                                                                    inputValue={this.state.foodEatTruaName[index] == undefined?"":this.state.foodEatTruaName[index]}
                                                                                    renderInput={params => {
                                                                                        return <TextField
                                                                                            placeholder='Nhập tên món ăn trưa'
                                                                                            {...params}
                                                                                            InputLabelProps={{
                                                                                                shrink: true,
                                                                                                style: {
                                                                                                    fontSize: 17,
                                                                                                    backgroundColor: "#FFF",
                                                                                                    paddingRight: 10,
                                                                                                    paddingLeft: 10,
                                                                                                    color: '#2e495c',
                                                                                                    fontWeight: 500,
                                                                                                    fontFamily: 'Montserrat'
                                                                                                }
                                                                                            }}
                                                                                            label=""
                                                                                            variant="outlined"
                                                                                            fullWidth
                                                                                        />
                                                                                    }}
                                                                                    onInputChange={(event, val) => {
                                                                                        if (event !== null){
                                                                                            this.state.foodEatTruaName[index] = val
                                                                                            this.setState(this.state.foodEatTruaName)
                                                                                            if (val === ""){
                                                                                                this.state.foodEatTruaId[index] = -1;
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    onChange={(e, val) => {
                                                                                        if (val?.id != undefined){
                                                                                            if (!this.state.foodEatTruaId.includes(val?.id)){
                                                                                                this.state.foodEatTruaId[index] = val?.id;
                                                                                                this.setState(this.state.foodEatTruaId)
                                                                                            }else {
                                                                                                this.state.foodEatTruaName[index] = "";
                                                                                                this.state.foodEatTruaId[index] = -1;
                                                                                                this.setState(this.state.foodEatTruaName)
                                                                                                this.setState(this.state.foodEatTruaId)
                                                                                                toast.error("Món ăn đã được chọn! Vui lòng chọn món ăn khác", {
                                                                                                    position: toast.POSITION.TOP_RIGHT,
                                                                                                    autoClose: 3000
                                                                                                });
                                                                                            }
                                                                                        }else {
                                                                                            this.state.foodEatTruaName[index] = "";
                                                                                            this.state.foodEatTruaId[index] = -1;
                                                                                            this.setState(this.state.foodEatTruaName)
                                                                                            this.setState(this.state.foodEatTruaId)
                                                                                        }
                                                                                    }}

                                                                                />

                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <Autocomplete
                                                                                    size="small"
                                                                                    options={this.getFoodEat("TOI")}
                                                                                    getOptionLabel={option => option.name?option.name:""}
                                                                                    style={{width: '100%'}}
                                                                                    inputValue={this.state.foodEatToiName[index] == undefined?"":this.state.foodEatToiName[index]}
                                                                                    renderInput={params => {
                                                                                        return <TextField
                                                                                            placeholder='Nhập tên món ăn trưa'
                                                                                            {...params}
                                                                                            InputLabelProps={{
                                                                                                shrink: true,
                                                                                                style: {
                                                                                                    fontSize: 17,
                                                                                                    backgroundColor: "#FFF",
                                                                                                    paddingRight: 10,
                                                                                                    paddingLeft: 10,
                                                                                                    color: '#2e495c',
                                                                                                    fontWeight: 500,
                                                                                                    fontFamily: 'Montserrat'
                                                                                                }
                                                                                            }}
                                                                                            label=""
                                                                                            variant="outlined"
                                                                                            fullWidth
                                                                                        />
                                                                                    }}
                                                                                    onInputChange={(event, val) => {
                                                                                        if (event !== null){
                                                                                            this.state.foodEatToiName[index] = val
                                                                                            this.setState(this.state.foodEatToiName)
                                                                                            if (val === ""){
                                                                                                this.state.foodEatToiId[index] = -1;
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    onChange={(e, val) => {
                                                                                        if (val?.id != undefined){
                                                                                            if (!this.state.foodEatToiId.includes(val?.id)){
                                                                                                this.state.foodEatToiId[index] = val?.id;
                                                                                                this.setState(this.state.foodEatToiId)
                                                                                            }else {
                                                                                                this.state.foodEatToiName[index] = "";
                                                                                                this.state.foodEatToiId[index] = -1;
                                                                                                this.setState(this.state.foodEatToiName)
                                                                                                this.setState(this.state.foodEatToiId)
                                                                                                toast.error("Món ăn đã được chọn! Vui lòng chọn món ăn khác", {
                                                                                                    position: toast.POSITION.TOP_RIGHT,
                                                                                                    autoClose: 3000
                                                                                                });
                                                                                            }
                                                                                        }else {
                                                                                            this.state.foodEatToiName[index] = "";
                                                                                            this.state.foodEatToiId[index] = -1;
                                                                                            this.setState(this.state.foodEatToiName)
                                                                                            this.setState(this.state.foodEatToiId)
                                                                                        }
                                                                                    }}

                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                style={{height: 35, marginRight: 12}}
                                                type="button"
                                                className="border-1-s background-btn type-button-fix btn btn-primary btn-sm mt-2"
                                                onClick={() => {
                                                    this.state.listBuaAn.push({
                                                        "sang": "",
                                                        "trua": "",
                                                        "toi": ""
                                                    })
                                                    this.setState(this.state.listBuaAn)
                                                }}
                                            >
                                                Thêm món
                                            </button>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thực phẩm dịch vụ/1 trẻ
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={headerMonAn}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!listMonAn ||
                                                                listMonAn.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listMonAn &&
                                                                    listMonAn.length > 0 &&
                                                                    listMonAn?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumber * this.state.pageSize +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <Autocomplete
                                                                                    size="small"
                                                                                    options={this.state.allFood}
                                                                                    getOptionLabel={option => option.name?option.name:""}
                                                                                    style={{width: '100%'}}
                                                                                    inputValue={this.state.foodName[index] ==undefined?"":this.state.foodName[index]}
                                                                                    renderInput={params => {
                                                                                        return <TextField
                                                                                            placeholder='Nhập tên món ăn'
                                                                                            {...params}
                                                                                            InputLabelProps={{
                                                                                                shrink: true,
                                                                                                style: {
                                                                                                    fontSize: 17,
                                                                                                    backgroundColor: "#FFF",
                                                                                                    paddingRight: 10,
                                                                                                    paddingLeft: 10,
                                                                                                    color: '#2e495c',
                                                                                                    fontWeight: 500,
                                                                                                    fontFamily: 'Montserrat',
                                                                                                    width: "100%"
                                                                                                }
                                                                                            }}
                                                                                            label=""
                                                                                            variant="outlined"
                                                                                            fullWidth
                                                                                        />
                                                                                    }}
                                                                                    onInputChange={(event, val) => {
                                                                                        if (event !== null){
                                                                                            this.state.foodName[index] = val
                                                                                            this.setState(this.state.foodName)
                                                                                        }
                                                                                    }}
                                                                                    onChange={(e, val) => {
                                                                                        if (val?.id != undefined){
                                                                                            let food = this.state.listFoodSelect[index];
                                                                                            if (food == undefined){
                                                                                                food = {
                                                                                                    buyRealTotalInput: 0,
                                                                                                    foodId: -1,
                                                                                                    massInput: 0,
                                                                                                    rationDisposeInput: 0,
                                                                                                    unitPriceInput: 0,
                                                                                                    unit: ""
                                                                                                }
                                                                                            }
                                                                                            food["foodId"] = parseFloat(val?.id)
                                                                                            this.state.listFoodSelect[index] = food
                                                                                            this.setState(this.state.listFoodSelect)
                                                                                        }else {
                                                                                            this.state.foodName[index] = ""
                                                                                            this.setState(this.state.foodName)
                                                                                        }
                                                                                    }}

                                                                                />
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <input
                                                                                    placeholder="VD: 50g"
                                                                                    maxLength={255} type="number"
                                                                                    className="form-control shadow-none"
                                                                                    value={this.state.listFoodSelect[index]?.massInput}
                                                                                    onChange={(event) => {
                                                                                        let food = this.state.listFoodSelect[index];
                                                                                        if (food == undefined){
                                                                                            food = {
                                                                                                buyRealTotalInput: 0,
                                                                                                foodId: -1,
                                                                                                massInput: 0,
                                                                                                rationDisposeInput: 0,
                                                                                                unitPriceInput: 0,
                                                                                                unit: ""
                                                                                            }
                                                                                        }
                                                                                        food["massInput"] = parseFloat(event.target.value)
                                                                                        this.state.listFoodSelect[index] = food
                                                                                        this.setState(this.state.listFoodSelect)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {this.getUnit(index)}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <input
                                                                                    placeholder="VD: 2%"
                                                                                    maxLength={255} type="number"
                                                                                    className="form-control shadow-none"
                                                                                    value={this.state.listFoodSelect[index]?.rationDisposeInput}
                                                                                    onChange={(event) => {
                                                                                        let food = this.state.listFoodSelect[index];
                                                                                        if (food == undefined){
                                                                                            food = {
                                                                                                buyRealTotalInput: 0,
                                                                                                foodId: -1,
                                                                                                massInput: 0,
                                                                                                rationDisposeInput: 0,
                                                                                                unitPriceInput: 0,
                                                                                                unit: ""
                                                                                            }
                                                                                        }
                                                                                        food["rationDisposeInput"] = parseFloat(event.target.value)
                                                                                        this.state.listFoodSelect[index] = food
                                                                                        this.setState(this.state.listFoodSelect)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <input
                                                                                    placeholder="VD: 2kg"
                                                                                    maxLength={255} type="number"
                                                                                    className="form-control shadow-none"
                                                                                    value={this.state.listFoodSelect[index]?.buyRealTotalInput}
                                                                                    onChange={(event) => {
                                                                                        let food = this.state.listFoodSelect[index];
                                                                                        if (food == undefined){
                                                                                            food = {
                                                                                                buyRealTotalInput: 0,
                                                                                                foodId: -1,
                                                                                                massInput: 0,
                                                                                                rationDisposeInput: 0,
                                                                                                unitPriceInput: 0,
                                                                                                unit: ""
                                                                                            }
                                                                                        }
                                                                                        food["buyRealTotalInput"] = parseFloat(event.target.value)
                                                                                        this.state.listFoodSelect[index] = food
                                                                                        this.setState(this.state.listFoodSelect)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                <input
                                                                                    placeholder="VD: 60.000"
                                                                                    maxLength={255} type="text"
                                                                                    className="form-control shadow-none"
                                                                                    value={Utils.formatMoney(this.state.listFoodSelect[index]?.unitPriceInput == undefined? 0: this.state.listFoodSelect[index]?.unitPriceInput)}
                                                                                    onChange={(event) => {
                                                                                        let food = this.state.listFoodSelect[index];
                                                                                        if (food == undefined){
                                                                                            food = {
                                                                                                buyRealTotalInput: 0,
                                                                                                foodId: -1,
                                                                                                massInput: 0,
                                                                                                rationDisposeInput: 0,
                                                                                                unitPriceInput: 0,
                                                                                                price: 0,
                                                                                                unit: ""
                                                                                            }
                                                                                        }
                                                                                        let unitPriceInput = parseFloat(event.target.value.toString().replaceAll(",", ""))
                                                                                        food["unitPriceInput"] = unitPriceInput
                                                                                        this.state.listFoodSelect[index] = food
                                                                                        this.setState(this.state.listFoodSelect)
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {this.getPrice(index)}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                </div>

                                            </div>
                                            {/*<div className="col-12 d-flex mb-2 bg-top-title mt-2">*/}
                                            {/*    Đánh giá thực đơn*/}
                                            {/*</div>*/}
                                            <button
                                                style={{height: 35, marginRight: 12}}
                                                type="button"
                                                className="border-1-s background-btn type-button-fix btn btn-primary btn-sm mt-2"
                                                onClick={() => {
                                                    this.state.listMonAn.push({
                                                        "name": "Tên món ăn "+this.state.listMonAn.length,
                                                        "trua": "",
                                                        "toi": ""
                                                    })
                                                    this.setState(this.state.listMonAn)
                                                }}
                                            >
                                                Thêm thực phẩm
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-thuc-don"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(CreateMenuManagement)